import NoDataToDisplay from "../../../charts/utils/NoData";
import { useState, useEffect, useContext, useMemo } from "react";
import { Expedicoes } from "../../Peças/Expedicoes/Expedicoes";
import { PecaParaOperacao } from "./PecaParaOperacao/PecaParaOperacao";
import { PropConfig } from "../../../types/EntityConfig";
import MultipleSelect from "../../../form/CustomInput/MultipleSelect/MultipleSelect";
import { FactoryFloorContext } from "../../../contexts/FactoryFloorContext";
import { useQuery } from "@tanstack/react-query";
import { genericGet, buildEndpoint } from "../../../services/api.service";
import CustomButtonSimple from "../../../components/CustomMiscellaneous/CustomButtonSimple";
import { ControloEQualidadeSpecifics } from "./ControloEQualidadeSpecifics";

const PecasFilterConfig: PropConfig = {
    id: 'id',
    label: 'Filtro peças',
    type: 'multi-select',
    options: {
        name: 'Filtrar peças',
        label: 'reference'
    }
}

const MaterialFilterConfig: PropConfig = {
    id: 'id',
    label: 'Filtro material',
    type: 'multi-select',
    options: {
        name: 'Filtrar por material',
        label: 'material.reference'
    }
}




export function ListagemPecasParaOperacao({
    pecasParaEntrega,
    setPecasParaEntrega,
    externalPecasFilter = []
}: { pecasParaEntrega: any, setPecasParaEntrega: Function, externalPecasFilter?: any }) {

    const [openIndex, setOpenIndex] = useState<number | null>(0);
    const [pecasToDisplay, setPecasToDisplay] = useState([]);
    const [pecasToFilter, setPecasToFilter] = useState(externalPecasFilter);
    const [materialsToFilter, setMaterialsToFilter] = useState([]);

    const { selectionValues } = useContext(FactoryFloorContext);

    useEffect(() => {
        setPecasToDisplay(pecasParaEntrega);
    }, [pecasParaEntrega])


    useEffect(() => {
        console.log("New pecas to filter: ", externalPecasFilter);
        setPecasToFilter(externalPecasFilter);
    }, [externalPecasFilter])

    const { data: anexos } = useQuery({
        queryKey: ['publicAnexos', selectionValues.obra],
        queryFn: () => genericGet(`/obras/${selectionValues.obra?.id}/anexos/public`)
    })


    const onFilterChange = (e: any) => {
        setMaterialsToFilter([]);
        setPecasToFilter(e);
    }



    const getPecasToFilter = () => {
        return pecasToDisplay.map((p: any) => p.peca);
    }


    const filterOptions = () => {

        const isNotIncludedOnFilter = (pd: any) => {
            return !pecasToFilter.map((pf: any) => pf?.reference).includes(pd?.reference);
        }
        return pecasToDisplay
            .map((p: any) => p.peca)
            .filter((pd: any) => isNotIncludedOnFilter(pd))
    }


    const materialOptions = () => {

        const isNotIncludedOnFilter = (pd: any) => {
            return !pecasToFilter.map((pf: any) => pf?.material?.reference).includes(pd?.material?.reference);
        }

        return pecasToDisplay
            .map((p: any) => p.peca)
            .filter((pd: any) => isNotIncludedOnFilter(pd)).filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.material.reference === value.material.reference
                )));

    }


    const listPecas = useMemo(() => {
        if (!pecasToFilter.length && !materialsToFilter.length) return pecasToDisplay;

        const referenceIncluded = (pd: any) => {
            return pecasToFilter.map((pf: any) => pf?.reference).includes(pd.peca?.reference) ||
                materialsToFilter.map((mtf: any) => mtf?.material?.reference).includes(pd.peca?.material?.reference);
        };
        return pecasToDisplay.filter(referenceIncluded);


    }, [pecasToDisplay, pecasToFilter, materialsToFilter])



    return (<div>
        {anexos ?
            <div className="pl-8 mb-4">
                <h1 className="font-bold mb-2 pl-2">Anexos (Obra {selectionValues.obra?.number})</h1>
                {anexos.map((anexo: any, idx: number) => (
                    <div key={idx} className={`w-1/2 flex justify-between m-1 border border-zinc-300 rounded-md`}>
                        <div className="flex w-full hover:underline hover:bg-zinc-200">
                            <a className="w-full p-2" href={buildEndpoint(`/obras/${selectionValues.obra?.id}/anexos/download/${anexo.id}`)} target='__blank'>
                                <span className="font-bold">{anexo.name}</span>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            : null}
        {selectionValues.operacao != 'Expedição' ?
            <>
                {pecasToDisplay?.length ?

                    <div className="w-full px-5">
                        <h3 className="text-lg font-bold pl-5">Operações para {selectionValues.operacao}</h3>
                        <div className="flex justify-between">
                            <div className="w-1/3 pl-5 mt-4">
                                <MultipleSelect
                                    formData={{}}
                                    getter={getPecasToFilter}
                                    defaultOptions={filterOptions()}
                                    value={pecasToFilter}
                                    onChange={onFilterChange}
                                    options={PecasFilterConfig.options}
                                />
                            </div>
                            <div className="w-1/3 pl-5 mt-4">
                                <MultipleSelect
                                    formData={{}}
                                    getter={getPecasToFilter}
                                    defaultOptions={materialOptions()}
                                    value={materialsToFilter}
                                    onChange={(e: any) => {
                                        setPecasToFilter([]);
                                        setMaterialsToFilter(e)
                                    }}
                                    options={MaterialFilterConfig.options}
                                />
                            </div>
                            {selectionValues.operacao === 'Controlo e Qualidade' ?
                                <ControloEQualidadeSpecifics pecasParaEntrega={pecasParaEntrega} /> : null
                            }
                        </div>

                        {listPecas.map((p: any, idx) => {
                            return (
                                <a id={p.id}>
                                    <PecaParaOperacao
                                        data={p}
                                        pecaIdx={idx}
                                        openIndex={openIndex}
                                        setOpenIndex={setOpenIndex}
                                        setPecasToDisplay={setPecasToDisplay}
                                    />
                                </a>
                            )
                        })}

                    </div>

                    : <NoDataToDisplay />}

            </>

            : <Expedicoes
                pecas={pecasToDisplay}
                setPecas={setPecasParaEntrega}
            />}



    </div>)




}